module.exports = __webpack_public_path__ + "img/Embed.b42069f4.png";